<template>
	<div></div>
</template>
<script>
import { mapState } from 'pinia';
import useStore from "@/useStore";

export default {

	components: {
	},
	computed: {
		...mapState(useStore, {
			pagedata: (store) => store.pagedata,

		}),
	},
	pagedata() {
		// eslint-disable-next-line prefer-destructuring
		const pagedata = this.pagedata;
		return pagedata;
	},
};
</script>
<style>
</style>
